import useFetchAndTrace from "../fetchWithTrace";
import settings from "../../../constants/settings";
import { useContext, useState } from "react";
import { useCustomAlert } from "../alerts";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "../commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";

export default function useUpdateRequiredAmountForProject(
  onSuccess?: () => void,
) {
  const { boardId, shipmentId } = useContext(
    BoardIdContext,
  ) as BoardShipmentIds;
  const [loading, setLoading] = useState<boolean>(false);
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();

  const errorHandler = () => {
    setLoading(false);
    customAlert("Failed to update required amount");
  };

  const updateQuantity = (partId: string | null, requiredAmount: number) => {
    const updateRequiredAmountHandler = async (response: Response) => {
      setLoading(false);
      if (response.ok) {
        if (onSuccess) {
          onSuccess();
        }
      } else if (response.status === 400) {
        const { detail } = (await response.json()) as { detail: string };
        customAlert(detail);
      } else {
        throw new Error("Failed to update required amount");
      }
    };

    setLoading(true);
    if (partId === null) {
      return;
    }
    void fetchAndTrace(
      `${settings.api_url}/boards/${boardId}/shipments/${shipmentId as string}/required-amount`,
      updateRequiredAmountHandler,
      errorHandler,
      {
        body: JSON.stringify({
          part_id: partId,
          required_amount: requiredAmount,
        }),
        method: "PUT",
      },
    );
  };

  return { updateQuantity, loading };
}
